exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.debug-tools-help[data-v-c4c636e2] {\n   color: #9E9E9E\n}\n", ""]);

// exports
